import { onMounted, onUnmounted, ref } from 'vue'

function getViewportSize() {
  if (typeof window === 'undefined') return { height: 0, width: 0 }
  const v = window.visualViewport
  return {
    height: v ? v.height : window.innerHeight,
    width: v ? v.width : window.innerWidth,
  }
}

export default function useVisualViewport() {
  const size = getViewportSize()
  const height = ref(size.height)
  const width = ref(size.width)

  function update() {
    if (typeof window === 'undefined' || !window.visualViewport) return
    height.value = window.visualViewport.height
    width.value = window.visualViewport.width
  }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return
    update()
    window.visualViewport.addEventListener('resize', update)
    window.visualViewport.addEventListener('scroll', update)
  })

  onUnmounted(() => {
    if (typeof window === 'undefined' || !window.visualViewport) return
    window.visualViewport.removeEventListener('resize', update)
    window.visualViewport.removeEventListener('scroll', update)
  })

  return { height, width }
}
